import React, { useEffect, useLayoutEffect, useState } from "react";
import { apiCall } from "../utils/Api";
import { message } from "antd";
import BlankSpace from "../content_creator/BlankSpace";
import HeadlineParagraph from "../content_creator/HeadlineParagraph";
import TextColumns from "../content_creator/TextColumns";
import ImageGif from "../content_creator/ImageGif";
import TableGrid from "../content_creator/TableGrid";
import TextOverImage from "../content_creator/TextOverImage";
import TextOverParallax from "../content_creator/TextOverParallax";
import TextOverVideo from "../content_creator/TextOverVideo";
import SideBySide from "../content_creator/SideBySide";
import ImageGrid from "../content_creator/ImageGrid";
import ImageCarousel from "../content_creator/ImageCarousel";
import Youtube from "../content_creator/Youtube";
import ProductSlider from "../content_creator/ProductSlider";
import ProductGrid from "../content_creator/ProductGrid";
import SingleTitleFeature from "../content_creator/SingleTitleFeature";
import CustomButton from "../content_creator/CustomButton";
import ButtonGrid from "../content_creator/ButtonGrid";

import Custom from "../content_creator/Custom";
import CustomEmbed from "../content_creator/CustomEmbed";
import PopupNotice from "../content_creator/PopupNotice";
import AboveSearchbarNotice from "../content_creator/AboveSearchbarNotice";
import ContactAndHours from "../content_creator/ContactAndHours";
import MapStoresLocation from "../content_creator/MapStoresLocation";
import Browse from "./Browse";
import Catalogues from "./Catalogues";
import FindABookstore from "../content_creator/FindABookstore";
import ButtonTop from "../content_creator/ButtonTop";
import BusinessDirectory from "./BusinessDirectory";
import TodaysPasscode from "../content_creator/TodaysPasscode";
import { useLocation } from "react-router";


// Unused for TBM

// import GiftCard from "../content_creator/GiftCard";
// import EventsCalendar from "../content_creator/EventsCalendar";
// import EventsCalendarUpcoming from "../content_creator/EventsCalendarUpcoming";
// import SingleEventFeature from "../content_creator/SingleEventFeature";
// import Events from "../content_creator/Events";
// import EventList from "../content_creator/EventList";
// import EventsGrid from "../content_creator/EventsGrid";
// import GiftCards from "../content_creator/GiftCards";
// import MailChimpEmbedded from "../content_creator/MailChimpEmbedded";

export default function Layout(props) {

    const { page = {} } = props;

    const {
        label = "",
        path = "",
        id = "",
        menu_id = "",
        search = "",
        url = null,
        type = "",
        is_v1 = false,
        link_type = "",
        submenu = []
    } = page;

    const loc = useLocation();
    const [results, setResults] = useState([]);
    const globals = window.sitesettings.global_content || [];

    const getPage = () => {
        apiCall("site_content/getPage", { page_id: (id === "h" ? 24402 : id) }, (_status, _result) => {
            if (_status) {
                setResults(_result);
            } else {
                message.error(_result.error)
            }
        });
    }

    useEffect(getPage, []);


    useLayoutEffect(() => {
        if (!loc.hash) return;

        const id = loc.hash.slice(1);
        let attempts = 0;

        const scroll = () => {
            const el = document.getElementById(id);
            if (!el || attempts > 5) return;

            const y =
                el.getBoundingClientRect().top +
                window.scrollY -
                110;

            window.scrollTo({ top: y, behavior: "smooth" });
            attempts++;
        };

        requestAnimationFrame(scroll);
    }, [results, loc.hash]);



    const drawComponenet = (_component) => {

        const {
            component = "headline_paragraph",
        } = _component;



        switch (component) {
            case "blank_space": return <BlankSpace content={_component} />
            case "headline_paragraph": return <HeadlineParagraph content={_component} />
            case "text_columns": return <TextColumns content={_component} />
            case "image_gif": return <ImageGif content={_component} />
            case "table_grid": return <TableGrid content={_component} />
            case "text_over_image": return <TextOverImage content={_component} />
            case "text_over_parallax": return <TextOverParallax content={_component} />
            case "text_over_video": return <TextOverVideo content={_component} />
            case "side_by_side_text_image": return <SideBySide content={_component} />
            case "image_grid": return <ImageGrid content={_component} />
            case "image_carousel": return <ImageCarousel content={_component} />
            case "youtube": return <Youtube content={_component} />
            case "product_slider": return <ProductSlider content={_component} />
            case "product_grid": return <ProductGrid content={_component} />
            case "single_title_feature": return <SingleTitleFeature content={_component} />
            case "events_calendar": return <></>
            case "events_calendar_upcoming": return <></>
            case "single_event_feature": return <></>
            case "custom_button": return <CustomButton content={_component} />
            case "button_grid": return <ButtonGrid content={_component} />
            case "scroll_to_top": return <ButtonTop content={_component} />
            case "gift_card_image": return <></>
            case "balance_checker": return <></>
            case "mailchimp_embedded": return <></>
            case "custom_html_css": return <Custom content={_component} />
            case "custom_embed": return <CustomEmbed content={_component} />
            case "popup_notice": return <PopupNotice content={_component} />
            case "above_searchbar_notice": return <AboveSearchbarNotice content={_component} />

            // Built-ins
            case "events": return <></>
            case "event_list": return <></>
            case "events_grid": return <></>
            case "gift_cards": return <></>
            case "contact_and_hours": return <ContactAndHours content={_component} />
            case "map_stores_location": return <MapStoresLocation content={_component} />
            case "browse": return <Browse content={_component} />
            case "catalogue": return <Catalogues content={_component} />
            case "remote_support": return <TodaysPasscode content={_component} />
            case "find_a_bookstore": return <FindABookstore content={_component} />
            case "business_directory": return <BusinessDirectory />

        }
    }



    return (
        <div key={"layout"}>
            {globals.filter(item => item.component !== "popup_notice").map((item, index) => {

                return <div key={item.id} id={item?.id} className="bm-component">{drawComponenet(item)}</div>
            })}
            {results.map((item, index) => {
                // Don't wrap browse component...
                return (item.component === "browse") ? drawComponenet(item) : <div key={item.id} id={item?.id} className="bm-component">{drawComponenet(item)}</div>
            })}
        </div>
    )

}